import { Skeleton, Stack, useTheme } from "@mui/material";
import { DashboardTile } from "components/Dashboard/DashboardTile";

export function OverviewSkeleton() {
  return (
    <>
      <TwoChartTileSkeleton />
      <ChartTileSkeleton />
      <ChartTileSkeleton />
      <ChartTileSkeleton />
    </>
  );
}

export function TwoChartTileSkeleton({ height = 40 }: { height?: number }) {
  const theme = useTheme();
  return (
    <DashboardTile size={12}>
      <Stack spacing={2}>
        <Skeleton variant="rectangular" height={theme.spacing(4)} />
        <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
          <Skeleton variant="rectangular" height={theme.spacing(height)} sx={{ flexGrow: 1 }} />
          <Skeleton variant="rectangular" height={theme.spacing(height)} sx={{ flexGrow: 1 }} />
        </Stack>
        <Skeleton variant="rectangular" height={theme.spacing(6)} />
      </Stack>
    </DashboardTile>
  );
}

export function ChartTileSkeleton({ height = 38 }: { height?: number }) {
  const theme = useTheme();
  return (
    <DashboardTile size={12}>
      <Stack spacing={2}>
        <Skeleton variant="rectangular" height={theme.spacing(4)} />
        <Stack direction="row" spacing={2}>
          <Skeleton variant="rectangular" height={theme.spacing(height)} sx={{ width: "100%" }} />
        </Stack>
      </Stack>
    </DashboardTile>
  );
}
